<template>
  <div ref="wrapperDiv" class="overflow-hidden relative w-full" :style="styles">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div ref="contentDiv" class="tiptap-content pb-[1.5rem]" v-html="content"></div>

    <!-- button -->
    <button
      v-if="shouldShowButton"
      class="font-brown font-medium text-blue hover:underline absolute bottom-[-1px] right-0 bg-gradient-to-r from-transparent via-white via-30% to-white pl-12"
      style="height: 1lh"
      @click="toggle"
    >
      {{ show ? 'less details' : '...more details' }}
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  previewLines: {
    type: Number,
    required: false,
    default: 2
  },
  content: {
    type: String,
    required: true
  }
})

const show = ref(false)

const styles = computed(() => {
  return {
    maxHeight: show.value ? 'none' : `${props.previewLines * 1.5}rem`
  }
})

// we want to hide the button if the content is short enough to fit in the preview
// here's the div with the max height on it
const wrapperDiv = ref<HTMLDivElement | null>(null)
const contentDiv = ref<HTMLDivElement | null>(null)

const { width: winWidth } = useWindowSize()

const shouldShowButton = ref(false)

const calcShow = () => {
  const wrapperHeight = wrapperDiv.value?.clientHeight
  const contentHeight = contentDiv.value?.clientHeight
  // if there's no height for one or the other, display the
  // button just in case
  if (!wrapperHeight || !contentHeight) return true
  // otherwise, if the content is taller than the wrapper, show the button
  shouldShowButton.value = contentHeight > wrapperHeight
}

// watch the content, the screen width, and the preview lines
// and recalc the should show based on those
watch(
  [wrapperDiv, contentDiv, () => props.content, () => props.previewLines, winWidth],
  () => {
    calcShow()
  },
  { immediate: true }
)

const toggle = () => {
  show.value = !show.value
}
</script>

<style>
@import '~/assets/css/tiptap-display.css';
</style>
